module.exports = __webpack_public_path__ + "media/images/athletes/3528-c28498d0d8c064197c847470a758330c.png";